export const enum ViewerUrlQuery {
    group = 'group',
    id = 'id',
    selectedFileId = 'selectedFileId',
    urlBase = 'urlBase',
}
